import { TableCell, TableRow, Typography } from "@mui/material";

interface NoRowsProps {
  title: string;
  colSpan: number;
}
export const NoRows = ({ colSpan, title }: NoRowsProps) => {
  return (
    <TableRow>
      <TableCell align="center" colSpan={colSpan} sx={{ py: 3 }}>
        <Typography paragraph>No {title} found</Typography>
      </TableCell>
    </TableRow>
  );
};
